import { ContentState } from "draft-js"
import { convertFromHTML } from "draft-js"

function getInlineTag(style) {
  switch (style) {
    case "BOLD":
      return "strong"
    case "ITALIC":
      return "em"
    case "UNDERLINE":
      return "u"
    default:
      return "span"
  }
}

function convertToHTML(contentState) {
  let html = ""
  let currentListType = null
  let listItems = []

  contentState.blocks.forEach((block, index) => {
    let blockText = block.text

    // Apply inline styles
    if (block.inlineStyleRanges && block.inlineStyleRanges.length > 0) {
      // Create an array to track style changes at each character position
      const styleChanges = []

      // Track opening and closing tags at each position
      block.inlineStyleRanges.forEach((range) => {
        const tag = getInlineTag(range.style)
        // Mark the start of a style
        if (!styleChanges[range.offset]) {
          styleChanges[range.offset] = []
        }
        styleChanges[range.offset].push(`<${tag}>`)

        // Mark the end of a style
        const endOffset = range.offset + range.length
        if (!styleChanges[endOffset]) {
          styleChanges[endOffset] = []
        }
        styleChanges[endOffset].unshift(`</${tag}>`) // Close tags in reverse order
      })

      // Build the formatted text
      let formattedText = ""
      for (let i = 0; i < block.text.length; i++) {
        // Add any opening tags at this position
        if (styleChanges[i]) {
          formattedText += styleChanges[i].join("")
        }
        // Add the character
        formattedText += block.text[i]
      }
      // Add any closing tags at the end
      if (styleChanges[block.text.length]) {
        formattedText += styleChanges[block.text.length].join("")
      }

      blockText = formattedText
    }

    // Handle list items by grouping them
    if (block.type === "unordered-list-item" || block.type === "ordered-list-item") {
      // If this is a new list or different list type, close the previous list
      if (currentListType !== block.type && currentListType !== null) {
        // Close the previous list
        html += currentListType === "unordered-list-item" ? "</ul>" : "</ol>"
        listItems = []
      }

      // Set the current list type
      currentListType = block.type

      // Add this item to the list
      listItems.push(`<li>${blockText}</li>`)

      // If this is the last block or the next block is not a list item, close the list
      const isLastBlock = index === contentState.blocks.length - 1
      const nextBlock = !isLastBlock ? contentState.blocks[index + 1] : null
      const isNextBlockDifferentType = nextBlock && nextBlock.type !== block.type

      if (isLastBlock || isNextBlockDifferentType) {
        // Open the list, add all items, and close the list
        if (block.type === "unordered-list-item") {
          html += `<ul>${listItems.join("")}</ul>`
        } else {
          html += `<ol>${listItems.join("")}</ol>`
        }

        // Reset for the next list
        currentListType = null
        listItems = []
      }
    } else {
      // If we were in a list and now we're not, close the list
      if (currentListType !== null) {
        html += currentListType === "unordered-list-item" ? "</ul>" : "</ol>"
        currentListType = null
        listItems = []
      }

      // Handle different non-list block types
      switch (block.type) {
        case "header-one":
          html += `<h1>${blockText}</h1>`
          break
        case "header-two":
          html += `<h2>${blockText}</h2>`
          break
        default:
          html += `<p>${blockText}</p>`
      }
    }
  })

  return html
}

// Custom HTML parser for Draft.js
export function enhancedConvertFromHTML(html) {
  if (!html) {
    return ContentState.createFromText("")
  }

  try {
    // Use the built-in convertFromHTML function
    const blocksFromHTML = convertFromHTML(html)

    // Check if we got valid blocks
    if (blocksFromHTML && blocksFromHTML.contentBlocks) {
      return ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap)
    } else {
      // Fallback to empty content
      return ContentState.createFromText("")
    }
  } catch (e) {
    console.error("Error converting HTML:", e)
    return ContentState.createFromText("")
  }
}

export { convertToHTML }

